export const maritalStatusOptions = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Prefer not to say",
];
